<button
  [ngClass]="[color, size]"
  [attr.type]="type"
  class="flex justify-content-center items-center drop-shadow-md shadow-fuchsia-950 text-white px-3 py-1 rounded-pill border-b-1 border-white border-opacity-30  hover:bg-opacity-75 hover:border-opacity-75">
  <ng-content></ng-content>
</button>
